<template>
  <div class="container">
    <div class="container-head">
      <div>
        <van-collapse v-model="activeNames">
          <van-collapse-item class="m-new-center" :title="$t('home.CoSub.news.name')" name="1" style="font-weight: 700">
            <div
              class="citem"
              v-for="(item, index) in tabList"
              :key="index"
              @click="tabChange(item.value)"
              style="font-weight: 400"
            >
              <i
                v-if="item.value === currentValue"
                style="font-size:12px; color:#115DE1"
                class="iconfont icon-CDC-right"
              ></i>
              <span>{{ item.value === -1 ? item.text : $getConfigText(item.text)}}</span>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
    <div class="container-list" v-if="newsList.length">
      <div
        class="list-item"
        v-for="(item, index) in newsList"
        :key="index"
        @click="toDetail(item)"
      >
        <div>
          <img class="item-pic" :src="item.imgUrl" />
        </div>
        <div class="item-title">{{item.title}}</div>
        <div class="time-and-type">
          <div class="item-time">{{item.publishTime.slice(0, 11)}}</div>
          <div>
            <div
              class="item-type"
              :style="{ backgroundColor: item.bgColor, color: item.fontColor }"
            >{{$getConfigText(item.typeName)}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty-content">
      <img :src="cdn_home_img + '/paas/empty.png'" alt />
      <span>{{$t('paas_system.system.news_null')}}</span>
    </div>
  </div>
</template>

<script>
import { commonParams } from "@/config/common.js"
import { News } from "@/models/news";
export default {
  data() {
    return {
      activeNames: [],
      currentValue: -1,
      typeList: [],
      tabList: [
        {
          text: this.$t('home.all'),
          value: -1
        }
      ],
      newsList: [],
      newsOriginList: []
    };
  },
  computed: {
    cdn_home_img() {
      return commonParams.CDN_HOME_IMG
    }
  },
  methods: {
    getType(typeId) {
      return this.typeList.find(e => e.id === typeId);
    },
    tabChange(value) {
      this.activeNames = [];
      this.currentValue = value;
      let filterList = [];
      if (value === -1) {
        filterList = this.newsOriginList;
      } else {
        this.newsOriginList.forEach(a => {
          if (a.type === value) {
            filterList.push(a);
          }
        });
      }
      this.newsList = filterList;
    },
    toDetail(news) {
      if(news.contentType === 1){
        window.open(news.url)
      }else{
        this.$router.push({
          path: `/m-newsDetail/${news.newsId}`
        })
      }
    }
  },
  created() {
    News.getNewsType().then(res => {
      this.typeList = res.sort((a, b) => {
        return a.sort - b.sort;
      });
      res.forEach(e => {
        this.tabList.push({
          text: e.typeName,
          value: e.id
        });
      });
      News.getNewsList().then(res => {
        if(res){
          this.newsOriginList = res;
          this.newsList = res;
          this.newsList.forEach(n => {
            this.typeList.forEach(t => {
              if (n.type === t.id) {
                n.bgColor = t.bgColor;
                n.fontColor = t.fontColor;
                n.typeName = t.typeName;
              }
            });
          });  
        }
      });
    });
  }
};
</script>

<style scoped>
.container-head {
  position: relative;
}
.title {
  height: 1.3rem;
  background-color: #fff;
  z-index: 999;
  line-height: 1.28rem;
  font-size: 14px;
  color: #333;
  font-weight: 700;
  padding-left: 0.67rem;
  font-family: PingFang SC;
  position: absolute;
  top: 0;
  left: 0;
}

.van-dropdown-menu__item {
  align-items: flex-end;
}

.container-list {
  margin-top: 1.5rem;
}

.list-item {
  width: 8.93rem;
  height: 8.48rem;
  background-color: #f8f7fa;
  margin: 0 auto;
  margin-bottom: 1.07rem;
}

.item-pic {
  width: 100%;
  height: 5.2rem;
}

.item-title {
  word-wrap: break-word;
  text-overflow: ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 16px;
  color: #000;
  font-weight: 700;
  margin: 0.3rem 0.61rem 0;

}

.time-and-type {
  display: flex;
  line-height: 0.67rem;
  margin: 0.64rem 0.61rem 0;
  align-content: space-between;
}

.item-time {
  flex: 1;
  font-size: 13px;
  color: #666;
}

.item-type {
  flex: 1;
  height: 0.67rem;
  border-radius: 0.35rem;
  text-align: center;
  font-size: 13px;
  padding: 0 0.2rem;
}

.citem {
  font-size: 13px;
  color: #333;
  padding: 11px 0;
  border-bottom: 1px solid #ebebeb;
}

.citem:last-of-type {
  border-bottom: none;
}

.citem:first-child {
  padding: 0 0 11px;
}

.cactive {
  color: #555;
}
.m-new-center{
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.13);
  position: fixed;
  top: 1.25rem;
  left: 0;
  width: 100%;
}
.van-hairline--top-bottom::after{
  border-width: 0;
}
.empty-content {
  width: 100%;
  height: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
img {
  width: 75%;
}
span {
  font-size: 18px;
  margin: 0 0 10px;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/templates/m-content/m-news.vue